export const sanitizeSingleLine = (text) => String(text || "").replace(/\s+/g, " ").trim();

export const normalizeMessageList = (messages) => {
  if (!Array.isArray(messages)) {
    return [];
  }
  return messages.map((item) => sanitizeSingleLine(item)).filter(Boolean);
};

export const mergeUniqueMessages = (...groups) => {
  const merged = [];
  groups.flat().forEach((item) => {
    const normalized = sanitizeSingleLine(item);
    if (normalized && !merged.includes(normalized)) {
      merged.push(normalized);
    }
  });
  return merged;
};

export const formatMessageListDisplay = (messages, { title = null } = {}) => {
  const items = normalizeMessageList(messages);
  if (!items.length) {
    return "";
  }

  const lines = [];
  if (title) {
    lines.push(title);
    lines.push("");
  }
  items.forEach((message, index) => {
    lines.push(`${String(index + 1).padStart(2, " ")}. ${message}`);
  });
  return lines.join("\n");
};

export const messageListCollapsedSummary = (messages, {
  emptyLabel,
  singlePrefix = "",
  multipleLabel = (count) => `${count} elementi — espandi per l'elenco completo`,
}) => {
  const items = normalizeMessageList(messages);
  if (!items.length) {
    return emptyLabel;
  }
  if (items.length === 1) {
    return singlePrefix ? `${singlePrefix}${items[0]}` : items[0];
  }
  return multipleLabel(items.length);
};

export const messageListExpandedRows = (messages, { minRows = 1, maxRows = 10, headerRows = 0 } = {}) => {
  const count = normalizeMessageList(messages).length;
  if (!count) {
    return minRows;
  }
  return Math.min(maxRows, count + headerRows);
};
